export function noise2D(x, y, seed) {
    const getX = (ix, iy) => {
    const s = Math.sin(ix * 12.9898 + iy * 78.233 + seed) * 43758.5453123;
    return s - Math.floor(s);
    };

    const ix = Math.floor(x);
    const iy = Math.floor(y);
    const fx = x - ix;
    const fy = y - iy;
    const ux = fx * fx * (3.0 - 2.0 * fx);
    const uy = fy * fy * (3.0 - 2.0 * fy);
    const a = getX(ix, iy);
    const b = getX(ix + 1, iy);
    const c = getX(ix, iy + 1);
    const d = getX(ix + 1, iy + 1);

    return a * (1 - ux) * (1 - uy) +
        b * ux * (1 - uy) +
        c * (1 - ux) * uy +
        d * ux * uy;
}